import { useContext, useEffect, useMemo, useState } from 'react';

import { useLazyQuery } from '@apollo/client';

import { AuthContext } from 'auth';
import { SEARCH_CLIENTS_LIGHT, SEARCH_CLIENTS_LIGHT_WORKER } from 'schemas';
import { IUser } from 'types';

import { IClientsReturnValue, TFilterClientsFn } from './interfaces';

export function useClients(
  filterClientsFn?: TFilterClientsFn,
  worker?: boolean
): IClientsReturnValue {
  const {
    data: { permissions },
  } = useContext(AuthContext);

  const [inputValue, setInputValue] = useState('');
  const [clients, setClients] = useState<IUser[]>([]);

  const query = useMemo(() => {
    return worker ? SEARCH_CLIENTS_LIGHT_WORKER : SEARCH_CLIENTS_LIGHT;
  }, [worker]);

  const [getClients, { data }] = useLazyQuery(query, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!permissions?.has('client_browse') && !permissions?.has('client_info'))
      return;

    if ((inputValue.length > 1 && worker) || inputValue.length > 3) {
      getClients({
        variables: { input: { q: inputValue }, first: 15, page: 1 },
      });
    } else {
      setClients([]);
    }
  }, [getClients, inputValue, permissions, worker]);

  useEffect(() => {
    if (data) {
      const newClients = data.clients.data;

      if (filterClientsFn) {
        setClients(newClients.filter(filterClientsFn));
      } else {
        setClients(newClients);
      }
    }
  }, [data, filterClientsFn]);

  return {
    inputValue,
    setInputValue,
    clients,
  };
}
